import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

Vue.prototype.$isCN = function () {
  return this.$root.$i18n.locale === "zh";
};

Vue.prototype.$setLocale = function (locale) {
  this.$i18n.locale = locale;

  const { params, path } = this.$route;
  if (params.lang) {
    this.$router.replace({
      ...this.$route,
      params: {
        ...params,
        lang: locale,
      },
    });
  } else if (path) {
    this.$router.replace({
      ...this.$route,
      name: undefined,
      path: `/${this.$i18n.locale}${path}/`,
    });
  } else {
    this.$router.replace(`/${locale}/`);
  }
};

export default ({ app }) => {
  const i18n = new VueI18n({
    locale: "zh",
    fallbackLocale: "zh",
  });
  // Set i18n instance on app
  // This way we can use it in middleware and pages asyncData/fetch
  app.i18n = i18n;

  app.router.beforeEach((to, from, next) => {
    const { params, path } = to;
    const { lang } = params;
    if (lang) {
      i18n.locale = lang;
      next();
    } else {
      next({
        ...to,
        name: undefined,
        path: `/${i18n.locale}${path}`,
      });
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/i18n.js